<!--文件上传插件,支持分片、续传和秒传-->
<template>
    <div class="uploade-box">
        <uploader 
            :options="options" 
            :autoStart="false" 
            ref="uploader"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            @file-progress="onFileProgress"
            @file-error="onFileError"
            @file-removed="onRemoveFile"
            class="uploader-example">
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop v-show="isDropShow"></uploader-drop>
            <uploader-btn v-if="!isOnlyImg" id="global-uploader-btn" :single="isSingleFile"></uploader-btn>
            <uploader-btn v-if="isOnlyImg" id="global-uploader-btn" :single="isSingleFile" :attrs="attrs"></uploader-btn>
            <uploader-list  v-show="isUploaderShow" class="uploader-list">
                <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}" v-show="isPanelShow">
                    <div class="file-title">
                        <h2>文件列表</h2>
                        <div class="operate">
                            <span v-show="!collapse" @click="collapse=true"><span class="reduce-icon"></span></span>
                            <span v-show="collapse" @click="collapse=false">+</span>
                            <span class="close" @click="close">×</span>
                        </div>
                    </div>
                    <transition name="slide">
                        <ul class="file-list" v-show="!collapse">
                            <li v-for="file in props.fileList" :key="file.id">
                                <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
                                <span class="remove-icon" @click="removeFile(file)">×</span>
                            </li>
                            <div class="no-file" v-if="!props.fileList.length">暂无待上传文件</div>
                        </ul>
                    </transition>
                </div>
            </uploader-list>
        </uploader>
    </div>
</template>

<script>
import SparkMD5 from "spark-md5"
import {mergeFile} from "@/assets/js/modules/shareApi"
import {getToken} from "@/assets/js/modules/auth"
export default {
    props:{
        isUploaderShow: {
            type: Boolean
        },
        isDropShow: {   //是否显示拖拽框
            type: Boolean,
            default: true,
        },
        isSingleFile: {   //是否单文件上传
            type: Boolean,
        },
        isPanelShow: {
            type: Boolean,
            default: true
        },
        isOnlyImg: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        uploader(){
            if(this.$refs.uploader){
                return this.$refs.uploader.uploader;
            }
            return null;
        },
        uploaderFileList(){
            if(this.$refs.uploader){
                let up = this.$refs.uploader.uploader;
                return up.fileList.splice(1,up.fileList.length-1);
            }
            return [];
        }
    },
    data() {
        return {
            options: {
                // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
                target: process.env.BASE_API + '/api/UpLoadFile/SliceUpLoadAsync',
                chunkSize: 2 * 1024 * 1024,   //分块上传每一块的大小,最后一块可能会大于这个值
                simultaneousUploads: 4,   //并发上传数
                maxChunkRetries: 3,       //最大自动失败重试上传次数
                singleFile: true,
                supportDirectory: false,    
                query: {},                //其它额外的参数
                headers: {                //额外的请求头  验证
                    "Authorization": "Bearer "+ getToken()
                },              
                testChunks: true,
                initFileFn: function(file) {   //上传文件初始化,可获取上传文件信息,而不用上传到内存中
                    
                },
                // 服务器分片校验函数，秒传及断点续传基础
                checkChunkUploadedByResponse: function(chunk, message) {
                    let objMessage = JSON.parse(message);
                    if (objMessage.Data.IsUpLoaded) {    //秒传
                        this.uploadedRes = objMessage;
                        this.isUploaded = true;
                        return true;
                    }else{
                        this.upLoadId = objMessage.Data.UpLoadId;
                    }
                    return (objMessage.Data.UpLoaded || []).indexOf(chunk.offset + 1) >= 0   //断点续传
                },
                categoryMap: {
                    image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp','tiff'],
                    document: ['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx','psd','ai'],
                    zip: ['kz','zip','7z','rar','ace','arj','bz2','cab','gz','lzh','tar']
                },
                parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                    return parsedTimeRemaining
                        .replace(/\syears?/, '年')
                        .replace(/\days?/, '天')
                        .replace(/\shours?/, '小时')
                        .replace(/\sminutes?/, '分钟')
                        .replace(/\sseconds?/, '秒')
                } 
            },
            attrs: {
                accept: 'image/*'
            },
            collapse: false,  
            isStartUpload: false,   //是否开始上传文件
            fileNameList: [],   //文件名列表
            regex: null,          //正则表达式用与判断哪些不能上传
        }
    },
    created(){
        this.options.singleFile = this.isSingleFile;
    },
    methods: {
        onFileAdded(file){
            if(this.regex && !this.regex.test(file.name)){
                this.$emit('fileAddError');
                this.$refs.uploader.uploader.removeFile(file);
                this.fileNameList[0] ="";
                this.$emit('getFileName',this.fileNameList);
                return;
            }
            if(this.options.singleFile){
                this.fileNameList[0] = file.name;
            }else{
                this.fileNameList.push(file.name);
            }
            file.fileExtension = file.getExtension();
            this.$emit('getFileName',this.fileNameList);
            this.computedMD5(file);   
        },
        onFileSuccess(rootFile, file, response, chunk){
            let res = JSON.parse(response);
            if(!res.Success){
                console.log(res.Message);
                return;
            }
            if(file.isUploaded){
                this.$emit('fileSuccess',[file.uploadedRes,file]);
                return;
            }
            let data = {
                Identifier: file.uniqueIdentifier,
                UpLoadId: file.upLoadId
            };
            mergeFile(data).then(res=>{
                if(res.data.Success){
                    this.$emit('fileSuccess',[res.data,file]);
                }
            })
        },
        onFileProgress(rootFile, file, chunk){
            //console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            this.$emit('fileProgress',file);
        },
        onFileError(){
            this.$emit('fileError');
        },
        onRemoveFile(file){
            
        },
        //手动点击移除
        removeFile(file){
            this.$emit('removeFile',file);
        },
        computedMD5(file){
            let fileReader = new FileReader();
            let time = new Date().getTime();
            let md5 = '';
            file.pause();
            fileReader.readAsArrayBuffer(file.file);
            fileReader.onload = (e => {
                if (file.size != e.target.result.byteLength) {
                    this.error('Browser reported success but could not read the file until the end.');
                    return
                }
                md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
                // 添加额外的参数
                // this.uploader.opts.query = {
                //     ...this.params
                // }
                //console.log(`MD5计算完毕：${file.id} ${file.name} MD5：${md5} 用时：${new Date().getTime() - time} ms`);
                file.uniqueIdentifier = md5;
                //file.resume(); //开始/继续文件上传
            });

            fileReader.onerror = function () {
                this.error('FileReader onerror was triggered, maybe the browser aborted due to high memory usage.');
            };
        },
        handClick(obj){
            if(!obj) return false;
            if(obj.fireEvent){
                obj.fireEvent('onclick');
            }else{
                var evObj = document.createEvent("MouseEvents");
                evObj.initMouseEvent("click");
                obj.dispatchEvent(evObj);
            }
        },
        clickme(res){    
            if(res){
                this.regex = res;
            }
            this.handClick(document.getElementById("global-uploader-btn"));
        },
        close(){
            this.$emit('closeUploader');
        }
    }
}
</script>

<style scoped>
 .uploader-list{
     position: fixed;
     z-index: 99;
     right: 15px;
     bottom: 15px;
     text-align: left;
 }
 .uploader-app{
     width: 520px;
 }
 .uploader-drop{
     height: 100%;
     display: none;
 }
 .file-panel{
     background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 7px 7px 0 0;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    transition: all 0.5s ease 0.5s;
 }
 .file-title{
     display: flex;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border-bottom: 1px solid #ddd;
 }
 .file-title>h2{
     font-size: 16px;
 }
 .file-list{
    position: relative;
    height: 240px;
    overflow-x: hidden;
    overflow-y: auto;
    min-width: 600px;
    background-color: #fff;
    font-size: 14px;
 }
 .file-list>li{
     background-color: #fff;
     position: relative;
 }
 .file-list .remove-icon{
    position: absolute;
    right: 2.5%;
    top: 7px;
    display: inline-block;
    width: 16px;
    height: 16px;
    font-size: 24px;
    cursor: pointer;
    z-index: 2;
 }
 .file-panel.collapse{
     background-color: #e7ecf2;
 }
 #global-uploader-btn {
    position: absolute;
    clip: rect(0, 0, 0, 0);
}
.operate{
    display: flex;
    flex: 1;
    text-align: right;
    justify-content: flex-end;
}
.operate span{
    font-size: 30px;
    margin-left: 10px;
    color: #6699ff;
    cursor: pointer;
}
.operate .reduce-icon{
    display: block;
    height: 0;
    padding: 0 8px;
    border: 1px solid #6699ff;
    margin-top: 22px;
}
.no-file{
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    height: 100%;
}
.slide-enter-active, .slide-leave-active{
    height: 240px;
    transition: height 0.5s ease;
}
.slide-enter,.slide-leave-active{
    height: 0;
}
.file-list>>>.uploader-file-icon[icon=image]:before{
    content: "";
    background:url(../../assets/img/image_icon.png) no-repeat;
    background-size: 24px 24px;
}
.file-list>>>.uploader-file-icon[icon=document]:before{
    content: "";
    background:url(../../assets/img/file_icon.png) no-repeat;
    background-size: 24px 24px;
}
.file-list>>>.uploader-file-icon[icon=zip]:before{
    content: "";
    background:url(../../assets/img/zip_icon.png) no-repeat;
    background-size: 24px 24px;
}
.file-list>>>.uploader-file-name{
    width: 42%;
}
.file-list>>>.uploader-file-size{
    width: 16%;
}
.file-list>>>.uploader-file-status{
    width: 34%;
}
.file-list>>>.uploader-file-meta{
    width: 3%;
}
.file-list>>>.uploader-file[status=paused] .uploader-file-resume,
.file-list>>>.uploader-file[status=uploading] .uploader-file-pause{
    display: none;
}
.file-list>>>.uploader-file-actions{
    width: 3%;
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/uploader.vue